import React, { useEffect, useRef, useState } from 'react';
import './index.less';
import Block from '../Block';
import CasesSwitch from './CasesSwitch';
import Screenshot from './Screenshot';
import InfoCard from './InfoCard';
import anime from 'animejs';
import { baseAnimeParams } from '../config';
import { KeyAdvantagePath } from '../KeyAdvantages';

export function IndustryCases() {
    const [selectIndex, setSelectIndex] = useState(0);
    const io = useRef<IntersectionObserver>();
    const [visible, setVisible] = useState(false);
    const trySelectIndex = useRef(-1);
    const $containerRef = useRef();
    function handleSelectIndexChange(selectIndex) {
        if (visible) {
            setSelectIndex(selectIndex);
        } else {
            trySelectIndex.current = selectIndex;
        }
    }

    useEffect(() => {
        anime({
            targets: ['#block-industry-cases'],
            ...baseAnimeParams,
            opacity: [0, 1],
            translateY: [-40, 0],
        });

        if ('IntersectionObserver' in window) {
            io.current = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio <= 0) {
                        setVisible(false);
                    } else {
                        setVisible(true);
                        if (trySelectIndex.current >= 0) {
                            setTimeout(() => {
                                setSelectIndex(trySelectIndex.current);
                                trySelectIndex.current = -1;
                            }, 1000);
                        }
                    }
                });
            });
            io.current.observe($containerRef.current);
        }
        return () => {
            io.current && io.current.disconnect();
        };
    }, []);

    return (
        <div ref={$containerRef}>
            <Block
                style={{
                    opacity: 0,
                }}
                id="block-industry-cases"
                title={
                    <h2 id="industry-cases">
                        <a href="#industry-cases">行业案例</a>
                    </h2>
                }
                description="INDUSTRY CASES"
            >
                <div className="industry-cases">
                    <KeyAdvantagePath contentId="industry-cases" />
                    <CasesSwitch
                        selectIndex={selectIndex}
                        setSelectIndex={handleSelectIndexChange}
                    />
                    <div className="content-show">
                        <Screenshot
                            selectIndex={selectIndex}
                            setSelectIndex={handleSelectIndexChange}
                        />
                        <InfoCard selectIndex={selectIndex} />
                    </div>
                </div>
            </Block>
        </div>
    );
}

export default React.memo(IndustryCases);
